






































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { commentFields } from '@/GraphQL/fragments';

@Component
export default class UserPageComments extends Vue {
  @Prop() uid!: string
  @Prop() user!: any

  comments: any[] = []
  loading: boolean = true
  order: string = ''

  getComments(variables: any = { reset: false }) {
    this.loading = true
    const query = `
      query GET_COMMENTS_BY($createdBy: String, $first: Int, $after: String,) {
        comments(first: $first, after: $after, createdBy: $createdBy, order: "-created_at") {
          data {
            ${commentFields}
          }
          nextCursor
        }
      }`

    let variablesConfig = {
      first: 5,
      after: null,
      order: this.order || 'created_at',
      createdBy: this.uid,
    }

    variables = { ...variablesConfig, ...variables }
    this.$http.get('graphql', { params: { query, variables, seeAll: true } })
      .then(r => {
        if (variables.reset) {
          this.comments = r.data.data.comments.data
        } else {
          this.comments.push(...r.data.data.comments.data)
        }
        this.pagination.nextCursor = r.data.data.comments.nextCursor
        this.loading = false
      })
  }

  @Watch('uid', { immediate: true })
  onUidChanged() {
    this.getComments()
  }

  pagination: any = {
    nextCursor: '',
  }
  get canNext() {
    return !!this.pagination.nextCursor
  }

  next() {
    this.getComments({ after: this.pagination.nextCursor })
  }

  created() {
    window.addEventListener('scroll', () => {
      if (!this.canNext) return
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
        this.next()
      }
    })
  }

}

